import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReusableHeader from "../../../reusableField/ReusableHeader";
import BackIcon from "../../../Images/backIcon.png";
import HomeIcon from "../../../Images/homeIcon.png";
import { useEffect } from "react";


const SyncConfiguration = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const fullState = location.state || {};
  const safeAccountName = fullState?.accountName;
  const safeRoleName = fullState?.roleName || fullState?.name;

  const handleBackToViewRole = () => {
    navigate("/productsConfiguration", { state: fullState }); // ✅ fixed: explicit route, not navigate(-1)
  };

  useEffect(() => {
    console.log("[SyncConfiguration] accountName:", safeAccountName);
    console.log("[SyncConfiguration] roleName:", safeRoleName);
  }, [safeAccountName, safeRoleName]);

  const handleBackToExperience = () => {
    navigate("/experience-configuration", {
      state: fullState,
    });
  };

  // ...rest of component unchanged

  return (
    <div className="h-screen bg-[#F7F7F7] ">
      <ReusableHeader />

      {/* Top Section */}
      {/* Top Section */}
      {/* Top Section */}
      <div className="flex justify-between items-start px-10 -mt-2 ml-1">
        <div>
          {/* Back Button */}
          <button
            onClick={handleBackToViewRole}
            className="flex items-center justify-center gap-2 h-[36px] px-5 bg-[#C21A17] text-white rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
          >
            <img src={BackIcon} alt="Back" className="w-4 h-4 object-contain" />
            Back
          </button>

          {/* Breadcrumb */}
          <div className="mt-3 ml-1 flex items-center text-[14px] text-[#939393]">
            {/* Account Name */}
            <span
              onClick={() => navigate("/admin")}
              className="cursor-pointer"
            >
              {safeAccountName}
            </span>

            <span className="mx-2">›</span>

            {/* Role Name */}
            <span
              onClick={handleBackToExperience}
              className="cursor-pointer"
            >
              {safeRoleName}
            </span>

            <span className="mx-2">›</span>

            {/* Experience Configuration */}
            <span
              onClick={() =>
                navigate("/experience-configuration", {
                  state: fullState,
                })
              }
              className="cursor-pointer"
            >
              Experience Configuration
            </span>

            <span className="mx-2">›</span>

            {/* Products Configuration */}
            <span
              onClick={() =>
                navigate("/productsConfiguration", {
                  state: fullState,
                })
              }
              className="cursor-pointer"
            >
              Products Configuration
            </span>

            <span className="mx-2">›</span>

            {/* Current Page */}
            <span className="font-semibold text-gray-800">
              Sync
            </span>
          </div>
        </div>

        {/* Home Button */}
        <button
          onClick={() => navigate("/admin")}
          className="flex items-center justify-center gap-2 h-[37px] px-4 bg-[#C21A17] text-white rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
        >
          <img src={HomeIcon} alt="Home" className="w-4 h-4 object-contain" />
          Home
        </button>
      </div>



      {/* Main Content */}
      <div className="flex flex-col items-center mt-12">

        {/* Heading */}
        <h1 className="text-[#B00000] text-[44px] font-bold tracking-tight">
          Sync Configuration
        </h1>

        {/* Subtitle */}
        <p className="-mt-[10px] text-center text-[18px] font-semibold text-[#393939] leading-[29px]">
          Configure and manage your platform experience with Sync and
          <br />
          master-level settings.
        </p>

        {/* Buttons */}
        {/* Buttons */}
        <div className="grid grid-cols-2 gap-x-6 gap-y-6 mt-8 w-fit mx-auto">

          <button
            onClick={() =>
              navigate("/role-details-configuration", { state: fullState })
            }
            className="
      w-[335px]
      h-[46px]
      bg-white
      border
      border-[#1F2020]
      text-[#B00000]
      text-[15px]
      font-semibold
      shadow-[-4px_4px_0px_#B00000]
      transition-all
      duration-200
      hover:-translate-x-[2px]
      hover:-translate-y-[2px]
      hover:shadow-[-6px_6px_0px_#B00000]
    "
          >
            Role Details Configuration
          </button>

          <button
            onClick={() =>
              navigate("/star-video-configuration", { state: fullState })
            }
            className="
      w-[335px]
      h-[46px]
      bg-white
      border
      border-[#1F2020]
      text-[#B00000]
      text-[15px]
      font-semibold
      shadow-[-4px_4px_0px_#B00000]
      transition-all
      duration-200
      hover:-translate-x-[2px]
      hover:-translate-y-[2px]
      hover:shadow-[-6px_6px_0px_#B00000]
    "
          >
            Role Overview Videos Configuration
          </button>

          <button
            onClick={() =>
              navigate("/assessment-configuration", { state: fullState })
            }
            className="
      w-[335px]
      h-[46px]
      bg-white
      border
      border-[#1F2020]
      text-[#B00000]
      text-[15px]
      font-semibold
      shadow-[-4px_4px_0px_#B00000]
      transition-all
      duration-200
      hover:-translate-x-[2px]
      hover:-translate-y-[2px]
      hover:shadow-[-6px_6px_0px_#B00000]
    "
          >
            Assessment Configuration
          </button>

          <button
            onClick={() =>
              navigate("/assessment-journey", { state: fullState })
            }
            className="
      w-[335px]
      h-[46px]
      bg-white
      border
      border-[#1F2020]
      text-[#B00000]
      text-[15px]
      font-semibold
      shadow-[-4px_4px_0px_#B00000]
      transition-all
      duration-200
      hover:-translate-x-[2px]
      hover:-translate-y-[2px]
      hover:shadow-[-6px_6px_0px_#B00000]
    "
          >
            Assessment Journey
          </button>

        </div>

      </div>

    </div>
  );
};

export default SyncConfiguration;